import React from 'react';
import Grid from '@mui/material/Grid';
import ViewDocx from '../components/ViewDocx'
import { useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import ReplayIcon from '@mui/icons-material/Replay';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import {HOST} from './config';
function CaseDocFilePreviewer(props) {
  
    if (props.isGenerating) {
      return  <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={120}    // keeps the area from collapsing
      >
        <CircularProgress
          size={40}        // px
          thickness={4}    // stroke-width
          color="primary"  // any theme palette key or custom CSS
        />
        <Typography sx={{p: 2}}> 
          Generating document with new changes...
        </Typography>
      </Box>
    }


  return (
    <>{
      (props.currentType == 'pdf' || props.currentType == 'docx') && 
            <>
              <Box position='absolute' style={{ right: 0, zIndex: 1000}}>
                <Box display='flex' sx={{width:"100%"}}>
                  {!props.isGenerating && props.uriToLoad &&
                    <IconButton sx={{m: 1.5}} onClick={props.handleDownload}><DownloadIcon /></IconButton>
                  }
                  <IconButton 
                    variant='outlined'
                    sx={{ m: 1.5, marginLeft: "auto", mr: 3 }} edge='end' onClick={props.handleRegenerate} ><ReplayIcon sx={{}}/></IconButton>
                </Box>
              </Box>
              {props.generatedStatus == 'SUCCESS' &&
                <ViewDocx fileType={props.currentType} zoomLevel={props.zoomLevel} uri={props.uriToLoad} />
              }
              {props.generatedStatus == 'ERROR' &&
                <>
                <Box sx={{height: "30px" }} >
                  <></>
                </Box>
                <Box sx={{ mt: 4}} >
                  <Alert sx={{mt: 4}} severity="error">
                    Generation failed. Please verify prepared fields before retrying.
                  </Alert>
                </Box>
              </>
              }
          </>
            }
    </>)
}
export default CaseDocFilePreviewer;
